/**
 * 新建资源默认选「免费解锁」，减少运营每次手选。
 * 按名字精确匹配而不写死 id：测试和正式的 id 不必相同，也不会选中「Sleep Sound iOS 免费解锁」这类同样带这几个字的组。
 */
export const FREE_UNLOCK_GROUP_NAME = '免费解锁'

/** 解锁组列表里「免费解锁」的 id；没有这一组时返回空字符串，调用方保持不选。 */
export function findFreeUnlockGroupId(options) {
  const hit = (options || []).find(
    (item) => item && String(item.groupName || '').trim() === FREE_UNLOCK_GROUP_NAME
  )
  return hit ? hit.id : ''
}

/**
 * 批量上传的默认解锁组：选中 stickers 且还没选时自动填「免费解锁」。
 * 换成别的类型时只撤回自动填的值；运营自己选过的不动，避免付费资源被悄悄设成免费。
 * @returns {{ id: number|string, autoFilled: boolean }}
 */
export function batchUnlockDefault({ type, currentId, autoFilled, options }) {
  if (type === 'stickers') {
    if (currentId) {
      return { id: currentId, autoFilled }
    }
    const id = findFreeUnlockGroupId(options)
    return { id, autoFilled: id !== '' }
  }
  if (autoFilled) {
    return { id: '', autoFilled: false }
  }
  return { id: currentId, autoFilled: false }
}
